import util from "@/mixins//util";
import alertMixins from "@/mixins/alertMixins";
let resultCnt = 0;
let hasSuccess = true;

export default {
    mixins: [alertMixins],
    // inject: {parentChange: {default: () => {}}},
    data() {
        return {
            fileType: '',
            imageMaxSize : 1024 * 1024 * 20,
            fileExceedText: '파일은 한개만 가능합니다.',
            files: [],
            deleteFiles: [],
        }
    },
    methods: {
        changeType(fileName) {
            this.fileType = fileName;
        },
        handleFileChange(file, fileList) {
            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');
            if(file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 용량을 초과했습니다!');
                fileList.pop();
            }else if(!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            }else{
                if(this.fileType === '' || !this.hasOwnProperty(this.fileType)) {
                    this.files = fileList;
                    if(this.parentChange) {
                        this.parentChange('files', this.files);
                    }
                    this.$forceUpdate();
                }else{
                    this[this.fileType] = fileList;
                    this.parentChange(this.fileType, fileList);
                    this.$forceUpdate();
                }
            }
        },
        onlyOnePhotoChange(file, fileList) {
            let maxSize = this.imageMaxSize;
            let type = file.raw.type.split('/');
            if(file.size > maxSize) {
                this.errorAlert('1회 업로드 가능 용량을 초과했습니다!');
                fileList.pop();
            }else if(!(type[1] === 'jpeg' || type[1] === 'png')) {
                this.errorAlert('이미지 파일만 업로드 가능합니다.')
                fileList.pop();
            }else{
                file.org_url = file.url;
                if(this.fileType === '' || !this.hasOwnProperty(this.fileType)) {
                    if(this.files.length > 0 && this.files[0].hasOwnProperty('a_idx') && this.files[0].a_idx != null) {
                        file.a_idx = this.files[0].a_idx;
                    }
                    this.files[0] = file;
                    this.$forceUpdate();
                    if(this.parentChange) {
                        this.parentChange('files', this.files);
                    }
                }else{
                    if(this[this.fileType].length > 0 && this[this.fileType][0].hasOwnProperty('a_idx') && this[this.fileType][0].a_idx != null) {
                        file.a_idx = this[this.fileType][0].a_idx;
                    }
                    this[this.fileType][0] = file;
                    this.$forceUpdate();
                    if(this.parentChange) {
                        this.parentChange(this.fileType, this[this.fileType]);
                    }
                }
            }
        },
        handleFileRemove(file, fileList) {
            if(file.a_idx) {
                this.deleteFiles.push(file);
                if(this.parentChange) {
                    this.parentChange('deleteFiles', this.deleteFiles);
                }
            }
            if(this.fileType === '' || !this.hasOwnProperty(this.fileType)) {
                this.files = fileList;
                if(this.parentChange) {
                    this.parentChange('files', this.files);
                }
                this.$forceUpdate();
            }else{
                this[this.fileType] = fileList;
                if(this.parentChange) {
                    this.parentChange(this.fileType, fileList);
                }
                this.$forceUpdate();
            }
        },
        handleFileExceed() {
            this.errorAlert(this.fileExceedText);
        },
        uploadFiles(files, type, id) {
            return new Promise((resolve, reject) => {

                if(files.length === 0) {
                    resolve(true)
                }
                return this.uploadApiFile(files, type, id, resolve, 0);
            })
        },
        uploadApiFile(files, type, id, resolve, fileIndex=0) {
            if(files[fileIndex].hasOwnProperty('raw')) {
                let file = files[fileIndex]
                let formData = new FormData();
                formData.append('files', file.raw);
                formData.append('a_container_type', type);
                formData.append('a_container_id', id);
                if(file.hasOwnProperty('a_idx')) {
                    formData.append('a_idx', file.a_idx);
                }
                try {
                    this.$api.$file.updateFile(formData).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != 1) {
                            hasSuccess = false;
                        }
                        resultCnt = resultCnt + 1;
                        if(resultCnt === files.length || hasSuccess === false) {
                            resolve(hasSuccess);
                            this.initData();
                        }else{
                            this.uploadApiFile(files, type, id, resolve, fileIndex+1);
                        }

                    })
                }catch (e) {
                    console.log(e)
                }
            }else{
                resultCnt = resultCnt + 1;
                if(resultCnt === files.length || hasSuccess === false) {
                    this.initData();
                    resolve(hasSuccess);
                }else{
                    this.uploadApiFile(files, type, id, resolve, fileIndex+1);
                }
            }
        },
        removeFiles(files) {
            return util.Array.each(files, (file, index, arr) => {
                if(file.hasOwnProperty('a_idx') && file.a_idx != null) {
                    let params = {
                        a_idx : file.a_idx
                    }
                    this.$api.$file.deleteFile(params).then(res => {
                        // console.log(res);
                    })
                }
            })
        },
        initData() {
            resultCnt = 0;
            hasSuccess = true;
        },
    }
}
